<template>
<b-modal id="modal-notify-users"
             title="Apziņot aktīvus lietotājus"
             ok-title="Izsūtīt"
             cancel-title="Atcelt"
             size="lg"
             @show="resetModal"
             @hidden="resetModal"
             @ok="sendTemplateToActiveUsers"
             :ok-disabled="template == null"
             centered
             scrollable>
      <TemplateSelect v-model="template"></TemplateSelect>
    </b-modal>
</template>
<script>
import {mapGetters, mapActions, mapMutations} from 'vuex';
import axios from 'axios';
import * as companyStoreTypes from '@/vuex/modules/company/company.store-types';
import * as rootStoreTypes from '@/vuex/root.store-types';
import * as templateStoreTypes from '@/vuex/modules/template/template.store-types'
import TemplateSelect from './TemplateSelect.vue';

export default {
    name: 'modal-notify-all-users',
    components: { TemplateSelect },
    data: () => ({
        template: null,
    }),
    created() {
        this.getTemplates();
    },
    computed: {
        ...mapGetters('company', {
            /** @type {Company|*} */
            currentCompany: companyStoreTypes.GET_CURRENT_COMPANY,
        }),
        ...mapGetters('template', {
            templates: templateStoreTypes.GET_TEMPLATES
        }),
        templateOptions() {
            return this.templates.map(tpl => ({ value: tpl, text: tpl.name }));
        }
    },
    methods: {
        ...mapMutations({
            /** @type {function|*} */
            setAlertData: rootStoreTypes.SET_ALERT_DATA,
        }),
        ...mapActions('template', {
            getTemplates: templateStoreTypes.ACTION_GET_TEMPLATES,
        }),
        resetModal() {
            this.template = null;
        },
        sendTemplateToActiveUsers() {
            axios
                .post(`/api/companies/${this.currentCompany.id}/users/notify-active-users`, 
                { templateId: this.template._id })
                .then(() => this.setAlertData({ type: 'success', dismissSecs: 10, message: 'Atgadinajums lietotājiem izsūtīts!' }))
                .catch(({
                    response: {
                        data: {
                            error
                        }
                    }
                }) => this.setAlertData({ type: 'danger', dismissSecs: 180, 
                message: `Izsūtīšanas laikā notika kļūda
                          Sekojošiem lietotājiem e-pasts nav piegādāts:
                          ${error.map(({name, surname, email}) => 
                          [name, `${surname}:`, email || 'E-pasts nav ievadīts'].join(' '))
                          .join('\n')
                        }` })
                )
        }
    }
}
</script>
